export const QUAD = Symbol("QUAD")
export const TRIAG = Symbol("TRIAG")
export const DOT = Symbol("DOT")
export const TRAPEZ = Symbol("TRAPEZ")
export const STUB = Symbol("STUB")
